import { render, staticRenderFns } from "./goodsDetailSet.vue?vue&type=template&id=035ed3b4&scoped=true"
import script from "./goodsDetailSet.vue?vue&type=script&lang=js"
export * from "./goodsDetailSet.vue?vue&type=script&lang=js"
import style0 from "./goodsDetailSet.vue?vue&type=style&index=0&id=035ed3b4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035ed3b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('035ed3b4')) {
      api.createRecord('035ed3b4', component.options)
    } else {
      api.reload('035ed3b4', component.options)
    }
    module.hot.accept("./goodsDetailSet.vue?vue&type=template&id=035ed3b4&scoped=true", function () {
      api.rerender('035ed3b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/appBasicSetup/goodsDetailSet.vue"
export default component.exports